import { AccountType } from "@/enums/account-type";

export default {
  isWizardCompleted: state => state.isWizardCompleted,
  companyId: state => state.company && state.company.id,
  canAddCompany: state =>
    state.companies.some(
      company =>
        company.company_user.type === AccountType.OWNER &&
        company.is_master &&
        company.can_add_new_companies
    ),
  canCreateNewFacility: state =>
    state.company && state.company.can_create_gmb_locations,
  allFacilitiesAccess: state =>
    state.company &&
    (state.company.company_user.all_facilities_access ||
      state.company.company_user.type === AccountType.OWNER ||
      state.company.company_user.type === AccountType.ADMIN),
  hasStoreLocator: state =>
    state.company && state.company.enabled_store_locator,
  hasReviewBooster: state =>
    state.company && state.company.enabled_review_booster,
  accountType: state => state.company.company_user.type,
  isSubscriptionPlanClient: state => state.company.is_subscription_plan_client,
  isUnpaidSubscription: state =>
    !state.company.has_billing_subscription &&
    state.company.is_subscription_plan_client,
  acquisitionCampaign: state => state.company.acquisition_campaign,
  facilitiesCount: state => state.company.facilities_count
};
